import React, { useEffect } from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { useWorkOrders } from "../../../data/WorkOrdersHook";
import { useWorkItemAgreements } from "../../../data/WorkItemAgreementsHook";
import "./WorkItemEntry.css";
import { useWorkItemCategories } from "../../../data/WorkItemCategoriesHook";
import EngineerAvailability from "../../engineerAvailability/EngineerAvailability";
import { useWorkOrderItems } from "../../../data/WorkItemHook";

function DomesticFieldReactiveEntry() {
  const workOrdersRepository = useWorkOrders();
  const workItemAgreementsRepository = useWorkItemAgreements();
  const workItemCategoryRepository = useWorkItemCategories();
  const workOrderItemsRepository = useWorkOrderItems();
  const workOrder = workOrdersRepository.getEntry();

  const anyTimeSlot = { id: "PATS003", title: "Any time" };

  const updateAppointment = (date, slot, agreedoutsidesla) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      agreedoutsidesla,
      preferredAppointmentDate: date,
      preferredAppointmentSlot: slot.id,
      preferredAppointmentSlotTitle: slot.title,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateAppointmentConfirmed = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      preferredAppointmentDate: "",
      preferredAppointmentSlot: anyTimeSlot.id,
      preferredAppointmentSlotTitle: anyTimeSlot.title,
      appointmentConfirmed: e.target.value,
      appointmentConfirmedTitle: e.target.selectedOptions[0].text,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateWorkItemCategory = (e) => {
    const current = workOrdersRepository.getEntry();

    const index = e.nativeEvent.target.selectedIndex;
    const workitemcategoryname = e.nativeEvent.target[index].text;

    const revised = {
      ...current,
      workitemcategoryid: e.target.value,
      workitemcategoryname,
    };
    // both seem to be used depending on the outer form so setting both seems to help setting urgency correctly
    workOrdersRepository.setEntry(revised);
    workOrderItemsRepository.setEntry(revised);
  };

  const updateJobSpecificAccessNotes = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, jobSpecificAccessNotes: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const workItemAgreements =
    workItemAgreementsRepository.getWorkItemAgreements();
  const workItemCategories = workItemCategoryRepository.getWorkItemCategories();

  const appointmentData = {
    appointmentConfirmed: workOrder.appointmentConfirmed,
    preferredAppointmentDate: workOrder.preferredAppointmentDate,
    slahours: workOrder.slahours,
    preferredAppointmentSlotTitle: workOrder.preferredAppointmentSlotTitle,
  };

  useEffect(() => {
    // this is to set the work item category on load properly

    const currentWorkItemCategory = workItemCategories.find((element => element.id === workOrder.workitemcategoryid)).name;
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      workitemcategoryname : currentWorkItemCategory,
    };
    // both seem to be used depending on the outer form so setting both seems to help setting urgency correctly
    workOrdersRepository.setEntry(revised);
    workOrderItemsRepository.setEntry(revised);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="work-order-item-section">
      <h3>Domestic Field Reactive Work Item Details</h3>
      <Container className="work-order-item-container">
        <Row>
          <Col>
            <Form.Group className="mb-3" controlId="workItemCategoryGroup">
              <Form.Label>Work Item Category</Form.Label>
              <Form.Select
                value={workOrder.workitemcategoryid}
                onChange={updateWorkItemCategory}
              >
                {workItemCategories.map((nextItem) => (
                  <option key={nextItem.id} value={nextItem.id}>
                    {nextItem.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" controlId="appointmentConfirmedGroup">
              <Form.Label>
                Will this be an agreed or not agreed appointment?
              </Form.Label>
              <Form.Select
                value={workOrder.appointmentConfirmed}
                onChange={updateAppointmentConfirmed}
              >
                {workItemAgreements.map((nextItem) => (
                  <option key={nextItem.id} value={nextItem.id}>
                    {nextItem.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <EngineerAvailability
              updateAppointment={updateAppointment}
              appointmentData={appointmentData}
            />

            <Form.Group className="mb-3" controlId="jobSpecificAccessNoteGroup">
              <Form.Label>Job Specific Access Notes</Form.Label>
              <Form.Control
                as="input"
                value={workOrder.jobSpecificAccessNotes}
                onChange={updateJobSpecificAccessNotes}
              />
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default DomesticFieldReactiveEntry;